import { ConfigItem } from 'v2types';

export const transformConfigRequest = (configs: ConfigItem[]): ConfigItem[] => {
  return configs.map((config: ConfigItem) => {
    return { ...(config.id && { id: config.id }), title: config.title, description: config.description || '--' };
  });
};
